/*
 * 
 * DATEPICKER
 */

app.config(function ($mdDateLocaleProvider) {

    $mdDateLocaleProvider.months = ['styczeń', 'luty', 'marzec', 'kwiecień', 'maj', 'czerwiec', 'lipiec', 'sierpień', 'wrzesień', 'listopad', 'grudzień'];

    $mdDateLocaleProvider.shortMonths = ['sty', 'lt', 'mar', 'kwi', 'maj', 'cze', 'lip', 'sie', 'wrz', 'paź', 'lis', 'gru'];

    $mdDateLocaleProvider.days = ['poniedziałek', 'wtorek', 'środa', 'czwartek', 'piątek', 'sobota', 'niedziela'];

    $mdDateLocaleProvider.shortDays = ['nd', 'pn', 'wt', 'śr', 'cz', 'pt', 'sb', 'nd'];

    $mdDateLocaleProvider.firstDayOfWeek = 1;

    $mdDateLocaleProvider.formatDate = function (date) {        
        if (typeof date != "undefined" && date != "" && date != null) {            
            var day = date.getDate();
            var monthIndex = date.getMonth();
            var year = date.getFullYear();

            return year + '-' + (monthIndex + 1 < 10 ? 0 : '') + (monthIndex + 1) + '-' + (day < 10 ? '0' : '') + day;
        } else if(typeof date=="undefined"){
            return "";
        } else{
            return date;
        }
    };
});

/*
 * ARIA
 */

app.config(function ($mdAriaProvider) {
    // Globally disables all ARIA warnings.
    $mdAriaProvider.disableWarnings();
});

app.config(function ($mdThemingProvider) {
    $mdThemingProvider.disableTheming();
});